import { render, staticRenderFns } from "./StatusCard.vue?vue&type=template&id=1258bad9&scoped=true"
var script = {}
import style0 from "./StatusCard.vue?vue&type=style&index=0&id=1258bad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1258bad9",
  null
  
)

export default component.exports